import {Stack, styled} from '@mui/material';

const TalkingPointsStack = styled(Stack)(({theme}) => ({
  position: 'relative',
  paddingBlock: theme.spacing(7),
  '::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 40,
    bottom: 0,
    width: '3px',
    backgroundColor: '#545454',
    zIndex: 0,
  },
  [`${theme.breakpoints.down('md')} and (min-aspect-ratio: 1/1)`]: {
    paddingTop: theme.spacing(7),
  },
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(7),
  },
}));

export default TalkingPointsStack;
